/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneInfluence from 'solis/logic/board/zone/influence';

import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class InfluenceEvent extends TimelineEvent
{
  constructor (zone, date, sourceColony, value)
  {
    super(zone);

    this.date = date;
    this.value = value;

    this.sourceColony = sourceColony;

    this.user = this.zone.getBoard().getColony(sourceColony).cass.user;
  }


  apply ()
  {
    super.apply();

    const influence = new ZoneInfluence(this.zone, this.sourceColony);

    influence.ensureInfluence();
    influence.updateInfluence(this.value, this.date);
  }


};
